import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { SortableInputSelect, Modal } from '@wajeez-web/components/ui';
// import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { CommonModalProps } from './Types';
import { CommonActions } from '@wajeez-web/stores/common';
import { AlertType } from '@wajeez-web/stores/common';
import { useEffectCancelled } from '@wajeez-web/components/helpers';
import { on } from 'events';
interface DynamicZoneModalProps extends CommonModalProps<any> {
  validDynamicZiones: number[] | undefined;
}

const DynamicZoneModal = ({
  isOpen,
  onClose,
  onSubmit,
  validDynamicZiones,
}: DynamicZoneModalProps) => {
  // const dispatch = useAppDispatch();
  const { type } = useParams<{ type: string }>();
  // const { collectionComponentTypes } = useAppSelector(
  //   (state) => state.collectionComponentTypes
  // );
  // const { components } = useAppSelector((state) => state.components);
  const [dynamicZoneState, setDynamicZoneState] = useState({
    selectedDynamicZone: [],
    initDynamicZone: [],
  });

  // useEffectCancelled((canceller: AbortController) => {
  //   CollectionComponentsServices.getCollectionComponentById(id, canceller).then(
  //     (res) => {
  //       let dynmicZones = res?.data.dynamicZone.map((item: any) => ({
  //         value: item.id,
  //         label: item.referenceName,
  //       }));
  //       setDynamicZoneState({
  //         selectedDynamicZone: dynmicZones,
  //         initDynamicZone: res?.data.dynamicZone,
  //       });
  //     }
  //   );
  // }, []);

  // useEffect(() => {
  // dynamicZoneModalState &&
  //   setValidDynamicZiones(
  //     collectionComponentTypes.find((item) => item.name === type)
  //       ?.allowedTypes
  //   );
  // }, [dynamicZoneModalState]);

  return (
    <Modal
      title={'Add To Dynamic Zone'}
      open={isOpen}
      onClose={onClose}
      onSubmit={() => {
        // CollectionComponentsServices.handleDynamicZoneComponentwithCollection(
        //   dynamicZoneState.selectedDynamicZone.map((item: any) => item.value),
        //   dynamicZoneState.initDynamicZone,
        //   id
        // ).then(() => {
        //   return Promise.all([
        //     setDynamicZoneModalState({ open: false, selected: '' }),
        //     dispatch(
        //       AlertActions.setAlert({
        //         for: 'page',
        //         show: true,
        //         messages: [
        //           {
        //             message: 'Successfully updated',
        //             code: 200,
        //             field: null,
        //           },
        //         ],
        //         type: AlertType.SUCCESS,
        //       })
        //     ),
        //   ]);
        // });
      }}
    >
      <SortableInputSelect
        name={'Add-to-Dynamic-Zone'}
        label={'Set dynamic zone'}
        isMulti={true}
        options={
          []
          // components
          // .filter(
          //   (item: any) =>
          //     validDynamicZiones &&
          //     validDynamicZiones.includes(Number(item.typeId))
          // )
          // .map((item: { referenceName: string; id: string }) => ({
          //   label: item.referenceName,
          //   value: item.id,
          // }))
        }
        onChange={(name, value: any) => {
          setDynamicZoneState({
            ...dynamicZoneState,
            selectedDynamicZone: value,
          });
        }}
        value={dynamicZoneState.selectedDynamicZone}
      />
    </Modal>
  );
};

export default DynamicZoneModal;
